<template>
    <div class="contact contact-phone" :class="`contact-phone-${style_class}`">
        <phone-call-icon size="1x"></phone-call-icon>
        <span>+38 093 766 34 64</span>
    </div>
</template>

<script>
    import { PhoneCallIcon } from 'vue-feather-icons'

    export default {
        name: "PhoneButton",
        props: {
            style_class: {
                type: String,
                default: ''
            }
        },
        components: {
            PhoneCallIcon
        }
    };
</script>

<style scoped lang="scss">
    .contact-phone {
        cursor: pointer;
    }
</style>
